import React, { useEffect, useState } from "react";
/** @jsxImportSource @emotion/react */
import tw, { styled } from "twin.macro";
import { LandingLayout, Loading } from "../../components";
import {
	btnStyle,
	inputStyle,
	LandingTitle,
} from "../../lib/styles/styleLibrary";
import lock from "../../assets/svg/lock.svg";
import { Input } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useHistory, useLocation } from "react-router";
import { Toast } from "../../lib/helpers/helpers";
import { ROUTES } from "../../settings/routes";
import { useDispatch, useSelector } from "react-redux";
import { getAuth } from "../../redux/reducers/authReducer";
import { resetPassword } from "../../redux/actions/authentication";

const Wrapper = styled.div`
	${tw`sm:p-8! md:p-16! sm:max-w-md sm:mx-auto md:max-w-none md:mx-0`}

	@media (min-width: 769px) and (max-width: 1023px) {
		padding: 16px !important;
	}
`;

const ResetPassword = (props) => {
	const history = useHistory();
	const location = useLocation();
	const dispatch = useDispatch();
	const auth = useSelector(getAuth);
	const [loading, setLoading] = useState(false);
	const searchParams = new URLSearchParams(location.search);
	const email = searchParams.get("email");
	const code = searchParams.get("code");

	const [fields, setFields] = useState({
		password: "",
		new_password: "",
	});
	useEffect(() => {
		setFields({ ...fields, email, code });
		// eslint-disable-next-line
	}, [email, code]);

	const handleReset = (e) => {
		e.preventDefault();

		if (fields.new_password === "" || fields.password === "") {
			Toast.fire({
				icon: "error",
				title: `Password cannot be empty`,
			});
			return;
		}

		if (fields.password !== fields.new_password) {
			Toast.fire({
				icon: "error",
				title: `Passwords do not match`,
			});
			return;
		}
		const data = {
			email,
			code,
			new_password: fields.new_password,
		};
		console.log(data);
		setLoading(true);
		dispatch(resetPassword(data));
	};

	useEffect(() => {
		try {
			if (!loading) {
				return;
			}
			setLoading(false);
			const { error, message, title } = auth;
			if (error) {
				Toast.fire({
					icon: "error",
					title: `${title}
					${message}`,
				});
			} else {
				Toast.fire({
					icon: "success",
					title: `${title}
					${message}`,
				});
				setTimeout(() => {
					history.push({
						pathname: ROUTES.LOGIN,
					});
				}, 1000);
			}
		} catch (error) {}
		// eslint-disable-next-line
	}, [auth]);
	return (
		<LandingLayout>
			<div tw="h-full flex! flex-col!">
				<Wrapper>
					<ArrowLeftOutlined
						tw="p-3 bg-gray-100 mb-12 rounded-full hover:bg-white"
						onClick={() => history.goBack()}
					/>

					<LandingTitle>
						Reset <br />
						Password
					</LandingTitle>

					<div tw="pt-8">
						<p tw="text-lg">
							Please enter a new password for <br />
							<b>{email ?? "your email"}</b>, then sign in
						</p>
					</div>

					<div tw="w-full">
						<form tw="flex flex-col sm:w-full md:w-full xl:w-8/12 lg:w-9/12">
							<Input.Password
								placeholder="Your password"
								type="password"
								value={fields.password}
								onChange={(e) =>
									setFields({
										...fields,
										password: e.target.value,
									})
								}
								css={inputStyle}
								prefix={
									<img
										src={lock}
										alt=""
										tw=" focus:opacity-100 hover:opacity-100 pr-2"
									/>
								}
							/>

							<Input.Password
								placeholder="Confirm password"
								type="password"
								css={inputStyle}
								value={fields.new_password}
								onChange={(e) =>
									setFields({
										...fields,
										new_password: e.target.value,
									})
								}
								prefix={
									<img
										src={lock}
										alt=""
										tw=" focus:opacity-100 hover:opacity-100 pr-2"
									/>
								}
							/>

							<button css={btnStyle} onClick={handleReset}>
								{loading ? <Loading /> : "Send "}
							</button>
						</form>
					</div>
				</Wrapper>{" "}
			</div>
		</LandingLayout>
	);
};

export default ResetPassword;
